/**
 * The single switch between the real backend and the in-memory fake.
 * `import { api } from '@/api/client'` everywhere; never import real.ts / mock directly.
 */
import type { Api } from './api';
import { createRealApi } from './real';
import { createMockApi } from './mock';

const useMock = import.meta.env.VITE_MOCK === '1' || import.meta.env.VITE_MOCK === 'true';

export const api: Api = useMock ? createMockApi() : createRealApi();
export { ApiError } from './api';
export type { Api } from './api';
